<template>
  <b-container fluid class="position-relative d-flex align-items-center justify-content-center" style="min-height: calc(100vh - 150px)">
    <b-button
      v-if="isAbleToCreateCommissionShipment"
      class="package-type mr-2"
      @click="$router.push({ path: '/packages/commission-shipment/new' })"
      variant="primary"
      size="sm"
      squared>
      Поручение на погрузку
    </b-button>
    <b-button
      v-if="isAbleToCreateAviaPi"
      class="package-type mr-2"
      variant="primary"
      size="sm"
      squared>
      Авиа ПИ
    </b-button>
    <b-button
      v-if="isAbleToCreateEcr"
      class="package-type mr-2"
      @click="$router.push({ path: '/ecr/new' })"
      variant="primary"
      size="sm"
      squared>
      Реестр Экспресс Грузов
    </b-button>
    <b-button
      v-if="isAbleToCreateHouseshipment"
      class="package-type mr-2"
      @click="$router.push({ path: '/ecr/house-shipment/new' })"
      variant="primary"
      size="sm"
      squared>
      Товарная партия
    </b-button>
  </b-container>
</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  export default {
    name: "CreatePackageMaster",
    data () {
      return {}
    },
    computed: {
      isAbleToCreateCommissionShipment () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'create_commissionshipment'
        })
        return (hasRights.length > 0)
      },
      isAbleToCreateAviaPi () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'create_avia_pi'
        })
        return (hasRights.length > 0)
      },
      isAbleToCreateEcr () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'create_ecr'
        })
        return (hasRights.length > 0)
      },
      isAbleToCreateHouseshipment () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'create_houseshipment'
        })
        return (hasRights.length > 0)
      },
      ...mapState(
        {
          userInfo: state => state.authorization.userInfo,
          mobile: state => state.mobile,
          tablet: state => state.tablet,
          desktop: state => state.desktop,
          largeDesktop: state => state.largeDesktop
        }
      )
    },
    watch: {},
    mounted () {},
    methods: {
      ...mapActions({
        // logOut: 'authorization/logout'
      }),
      ...mapMutations({
        // toggleMenu: 'toggleMenu'
      })
    }
  }
</script>

<style lang="scss" scoped>
 .package-type {
   cursor: pointer;
 }
</style>
